import config from "@/config";
import { ListObjectsV2Command } from "@aws-sdk/client-s3";

// Files can live under either layout (see DepositFileList.vue)
function depositFilePrefixes(identityId, depositId) {
  return [
    `private/${identityId}/${depositId}/`,
    `private/${identityId}/deposits/${depositId}/`,
  ];
}

// Returns true as soon as any uploaded file (not a folder marker) is found
export async function depositHasFiles(client, identityId, depositId) {
  for (const Prefix of depositFilePrefixes(identityId, depositId)) {
    let ContinuationToken;
    do {
      const out = await client.send(new ListObjectsV2Command({
        Bucket: config.bucketName,
        Prefix,
        ContinuationToken,
      }));
      if ((out.Contents || []).some(o => o.Key && !o.Key.endsWith('/'))) return true;
      ContinuationToken = out.IsTruncated ? out.NextContinuationToken : undefined;
    } while (ContinuationToken);
  }
  return false;
}

// Metadata keys look like private/<identityId>/deposits/<depositId>
export function identityIdFromDepositKey(key) {
  return (key || '').split('/')[1] || null;
}
